import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { api } from "../../common/setupApi";
import { selectUser } from "../user/userSlice";

export const getDataStudios = createAsyncThunk(
  "dataStudio/get",
  async (_, { getState, rejectWithValue }) => {
    const userPk = selectUser(getState()).data.pk;
    // return Promise.resolve([{
    //     id: 0,
    //     src: "https://datastudio.google.com/embed/reporting/dfb86b08-5568-4383-826f-748a943b611f/page/p_8fb05tqcqc",
    //     height: 1000,
    //     title: "Indispo"
    // }])
    return api
      .get("datastudios/")
      .then((res) => {
        return { userPk, dataStudios: res.data };
      })
      .catch((err) => {
        return rejectWithValue(err.response?.data);
      });
  },
  {
    condition: (params, { getState }) => {
      if (params?.ignoreCondition) {
        return true;
      }
      // https://redux-toolkit.js.org/api/createAsyncThunk#canceling-before-execution
      const { status } = selectDataStudios(getState());
      if (status === "fulfilled" || status === "pending") {
        // Already fetched or in progress, don't need to re-fetch
        return false;
      }
    },
  }
);

export const toggleDataStudio = (id) => async (dispatch, getState) => {
  const userPk = selectUser(getState()).data.pk;
  dispatch(dataStudioActions.toggleDataStudio({ id, userPk }));
};

const initialState = {
  status: "idle",
  data: [],
  error: null,
  layouts: {},
};

const dataStudioSlice = createSlice({
  name: "dataStudio",
  initialState,
  reducers: {
    add: (state, action) => {
      state.data.push(action.payload);
    },
    set: (state, action) => {
      state.data = state.data.map((d) =>
        d.id === action.payload.id ? action.payload : d
      );
    },
    delete: (state, action) => {
      state.data = state.data.filter((d) => d.id !== action.payload);
    },
    toggleDataStudio: (state, action) => {
      const { userPk, id } = action.payload;
      localStorage.setItem(`user${userPk}_coll_data_studio_displayed`, id);
      state.layouts.colDisplayedId = id;
    },
    setDataStudioDisplayedId: (state, action) => {
      state.layouts.colDisplayedId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDataStudios.pending, (state) => {
        state.status = "pending";
        state.error = null;
      })
      .addCase(getDataStudios.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.data = action.payload.dataStudios;

        const userPk = action.payload.userPk;
        const dataStudioIds = action.payload.dataStudios.map((d) => d.id);
        const current =
          JSON.parse(
            localStorage.getItem(`user${userPk}_coll_data_studio_displayed`)
          ) || null;
        // utile si un autre coach supprime un data studio
        const newLayout = dataStudioIds.includes(current) ? current : null;
        localStorage.setItem(
          `user${userPk}_coll_data_studio_displayed`,
          newLayout
        );
        state.layouts.colDisplayedId = newLayout;
      })
      .addCase(getDataStudios.rejected, (state, action) => {
        state.status = "rejected";
        state.error = action.payload;
      })
      .addCase("auth/logout", () => initialState);
  },
});

export const dataStudioActions = dataStudioSlice.actions;

const _selectDataStudios = (state) => state.dataStudio;

export const selectDataStudios = createSelector(
  [(state) => _selectDataStudios(state)],
  (dataStudio) => {
    const data = dataStudio.data || [];
    const status = dataStudio.status;
    const error = dataStudio.error;
    const isLoading = status === "pending";
    return { data, status, error, isLoading };
  }
);

const _selectDataStudioLayouts = (state) => state.dataStudio.layouts;

export const selectDataStudioLayouts = createSelector(
  [(state) => _selectDataStudioLayouts(state)],
  (layouts) => {
    return {
      colDataStudioDisplayedId: layouts.colDisplayedId || null,
    };
  }
);

export const selectSelectedDataStudio = createSelector(
  [
    (state) => selectDataStudioLayouts(state),
    (state) => selectDataStudios(state),
  ],
  (layouts, dataStudios) => {
    const { colDataStudioDisplayedId: id } = layouts;
    const { data } = dataStudios;
    return data.find((d) => d.id === id) || {};
  }
);

export default dataStudioSlice.reducer;
